export default {
  company(state) {
    return state.company
  },
  companies(state) {
    return state.companies
  },
  userCompanyNew(state) {
    return state.userCompany
  },
  companyTypes(state) {
    return state.types
  },
}
